import { getFormUser } from "../store";
import en from "./resources/en.json";
import it from "./resources/it.json";

export const TRANSLATIONS = { en, it } as const;
export const AVAILABLE_LANGUAGES = ["en", "it"] as const;
export const FALLBACK_LANGUAGE = "en";
export type AvailableLanguages = (typeof AVAILABLE_LANGUAGES)[number];
export type Translations = typeof TRANSLATIONS;

let currentLanguage: AvailableLanguages = "it";

export function getCurrentLanguage(): AvailableLanguages {
  return currentLanguage;
}

// Change application language
export function changeLanguage(lang: AvailableLanguages): void {
  currentLanguage = lang;
  document.querySelectorAll("[data-translate]").forEach((element) => {
    const key = element.getAttribute("data-translate");
    if (!key) return;

    const keys = key.split(".");
    let translation = TRANSLATIONS[currentLanguage];

    for (const k of keys) {
      // @ts-expect-error go down the rabbit hole of the translation objects
      translation = translation[k];
    }

    if (element instanceof HTMLInputElement) {
      // @ts-expect-error
      element.placeholder = translation as string;
    } else {
      // @ts-expect-error
      element.textContent = translation as string;
    }
  });
  updateFormLabels();
}

function updateFormLabels(): void {
  if (getFormUser() && getFormUser().additionalData) {
    getFormUser().additionalData.forEach((data: any) => {
      const fieldLabel = data.text[currentLanguage] || data.text[FALLBACK_LANGUAGE] || Object.values(data.text)[0];
      const label = document.getElementById(`span.${fieldLabel}`);
      if (label) {
        label.textContent = fieldLabel;
      }
    });
  }

  const privacyContainer = document.getElementById(
    "privacySettings"
  ) as HTMLElement;
  if (!getFormUser() || !getFormUser().privacyPolicy) return;

  getFormUser().privacyPolicy.forEach((privacy: any) => {
    const label = privacyContainer.querySelector(
      `label[for="${privacy.id}"]`
    ) as HTMLLabelElement;
    if (label) {
      label.textContent = privacy.text[currentLanguage];
    }
  });
}
